import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../../../interfaces/IReduxState";

export const TutorReportListSlice = createSlice({
  name: "TutorReportListSlice",
  initialState: {} as IReduxState<any>,
  reducers: {
    TutorReportList: (state, _: PayloadAction<any>) => {
      state.isLoading = true;
    },
    successTutorReportList: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureTutorReportList: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearTutorReportList: (state) => {
      state.data = {};
    },
  },
});

export const {
  TutorReportList,
  failureTutorReportList,
  successTutorReportList,
  clearTutorReportList,
} = TutorReportListSlice.actions;

export default TutorReportListSlice.reducer;
